import Cookies from 'js-cookie'
import { axiosInstance } from './axios'

class TokenRefresher {
    private static instance: TokenRefresher
    public isRefreshing = false
    private refreshPromise: Promise<string | void> | null = null

    private constructor() {}

    public static getInstance(): TokenRefresher {
        if (!TokenRefresher.instance) {
            TokenRefresher.instance = new TokenRefresher()
        }
        return TokenRefresher.instance
    }

    public async refreshToken(): Promise<string | void> {
        // If already refreshing, return the existing promise
        if (this.isRefreshing && this.refreshPromise) {
            return this.refreshPromise
        }

        const refreshToken = Cookies.get('refreshToken')
        if (!refreshToken) return this.logoff()

        this.isRefreshing = true

        // Store the promise so it can be reused by concurrent calls
        this.refreshPromise = axiosInstance
            .request({
                url: '/v1/auth/refresh',
                method: 'POST',
                data: { refreshToken },
            })
            .then((response: any) => {
                Cookies.set('JWT', response.token, {
                    expires: 1,
                    sameSite: 'lax',
                })
                Cookies.set('refreshToken', response.refreshToken, {
                    expires: 1,
                    sameSite: 'lax',
                })
                return response.token
            })
            .catch(e => {
                console.error(e)
                this.logoff()
            })
            .finally((t: string | void) => {
                this.isRefreshing = false
                this.refreshPromise = null
                return t
            })

        return this.refreshPromise
    }

    public logoff(redirect: boolean = true): void {
        Cookies.remove('JWT')
        Cookies.remove('refreshToken')
        Cookies.remove('tokenSuporte')
        if (redirect) window.location.href = '/'
    }
}

export default TokenRefresher.getInstance()
